import { createFeature, createReducer, on } from '@ngrx/store';

import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { StatsUpdateLogActions } from './stats-update-log.actions';

export interface State {
    error: SharedErrorObjectI | null;
    loaded: boolean;
    loading: boolean;
    data: any;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
};

export default createFeature({
    name: 'statsUpdateLog',
    reducer: createReducer(
    initialState,
    on(StatsUpdateLogActions.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(StatsUpdateLogActions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(StatsUpdateLogActions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
    })),
    on(StatsUpdateLogActions.load, (state: State, { }): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
)}
);
